// src/components/Navbar.js

import {
    Box,
    Flex,
    HStack,
    IconButton,
    Link,
 // enable for shoppingbag:   Text,
    VStack,
    useDisclosure
} from "@chakra-ui/react";

import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
// enable for shoppingbag: import { HiOutlineShoppingBag } from "react-icons/hi";
// enable for shoppingbag: import { useProducts } from "../pages/ProductContext";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebaseConfig";

import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";

const Navbar = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
 // enable for shoppingbag:   const { cartItems } = useProducts();
    const [user] = useAuthState(auth);

 // enable for shoppingbag   const totalQuantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);

    return (
        <Box
            as="nav"
            backdropFilter="blur(8px)"
            bg="rgba(249, 250, 247, 0.3)"
            //bg="rgba(236, 240, 229, 0.6)"
            px={8}
            py={2}
            position="fixed"
            width="100%"
            top="0"
            zIndex="100"
            height="80px"
        >
            {/* Topp-linje (desktop) */}
            <Flex alignItems="center" justifyContent="space-between" h="100%">
                {/* Logo (venstre) */}
                <Link href="/" fontSize="xl" fontWeight="bold" color="#1D3C34">
                    Vangen Wood
                </Link>

                {/* Navigasjonslenker (midten, kun desktop) */}
                <HStack spacing={6} display={{ base: "none", md: "flex" }}>
                <Link href="/about" _hover={{ color: "#1D3C34", fontWeight: "bold" }}>
                        OM
                    </Link>
                    <Link href="/portfolio" _hover={{ color: "#1D3C34", fontWeight: "bold" }}>
                        PRODUKTER
                    </Link>
                    <Link href="/contact" _hover={{ color: "#1D3C34", fontWeight: "bold" }}>
                        KONTAKT
                    </Link>
                    {/* <Link href="/" _hover={{ color: "#1D3C34", fontWeight: "bold" }}>
                        Hjem
                    </Link> */}
               
                </HStack>

                {/* Høyre side: Handlekurv + Innlogging/Utlogging + Mobilknapp */}
                <HStack spacing={4}>
{/* Handlekurv
                    <Link
                        href="/cart"
                        _hover={{ color: "#1D3C34" }}
                        display="flex"
                        alignItems="center"
                        position="relative"
                    >
                        <Text mr={2}>Cart</Text>
                        <Box position="relative">
                            <HiOutlineShoppingBag size="24px" color="lightblue" />
                            {totalQuantity > 0 && (
                                <Box
                                    position="absolute"
                                    top="-6px"
                                    right="-6px"
                                    bg="green.600"
                                    color="white"
                                    borderRadius="full"
                                    width="18px"
                                    height="18px"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    fontSize="12px"
                                    fontWeight="bold"
                                >
                                    {totalQuantity}
                                </Box>
                            )}
                        </Box>
                    </Link>

*/}
               {/* Login/Logout */}
          {user ? <LogoutButton /> : <LoginButton />}

                    {/* Mobil: Hamburger / X-knapp */}
                    <IconButton
                        display={{ base: "flex", md: "none" }}
                        icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                        variant="ghost"
                        onClick={isOpen ? onClose : onOpen}
                        bg="rgba(249, 250, 247, 0.3)" // Samme bakgrunn som headerbar
                        _hover={{ bg: "rgba(249, 250, 247, 0.5)" }}
                        _active={{ bg: "rgba(249, 250, 247, 0.7)" }}
                    />
                </HStack>
            </Flex>

            {/* Mobilmeny (vises kun når isOpen = true) */}
            {isOpen && (
                <Box
                    position="absolute"
                    top="80px"
                    left="8px"
                    width="100%"
                    bg="rgba(249, 250, 247, 0.6)"
                    // bg="#5f9482" // Fast grønn bakgrunn lik header/about
                    zIndex={99}
                    boxShadow="md"
                    py={6}
                    opacity={isOpen ? 1 : 0}
                    transition="opacity 0.4s ease"
                >
                    <VStack spacing={6} align="start">
                        <Link href="/" fontSize="lg" fontWeight="bold" textAlign="left" _hover={{ color: "#1D3C34", fontWeight: "extrabold" }}>
                            Hjem
                        </Link>
                        <Link href="/portfolio" fontSize="lg" fontWeight="bold" textAlign="left" _hover={{ color: "#1D3C34", fontWeight: "extrabold" }}>
                            Produkter
                        </Link>
                        <Link href="/about" fontSize="lg" fontWeight="bold" textAlign="left" _hover={{ color: "#1D3C34", fontWeight: "extrabold" }}>
                            Om
                        </Link>
                        <Link href="/contact" fontSize="lg" fontWeight="bold" textAlign="left" _hover={{ color: "#1D3C34", fontWeight: "extrabold" }}>
                            Kontakt
                        </Link>
                    </VStack>
                </Box>
            )}
        </Box>
    );
};

export default Navbar;
